import { DecisionContext, DecisionTypeHandler, DbotEventDispatcher } from "../common/commonDomain";
import { Procura, ProcuraForm } from "./procuraDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: Procura,
): ProcuraForm {
  return new ProcuraForm(context, data);
}

export function isValid(form: ProcuraForm): boolean {
  return form.isValid;
}

export function validate(form: ProcuraForm): boolean {
  return form.validate();
}

export function applyForm(form: ProcuraForm): Procura {
  return {
    type: DecisionType.procura,

    isProcuraAssignedByRole: form.isProcuraAssignedByRole.value,
    isProcuraAssignedByName: form.isProcuraAssignedByName.value,
    isProcuraAssignedByFreetext: form.isProcuraAssignedByFreetext.value,

    procuraAssignedToByRole: form.procuraAssignedToByRole.value
      .filter((e) => e.isSelected)
      .map((e) => e.id),
    procuraAssignedToByName: form.procuraAssignedToByName.value.filter((e) => e.isSelected),
    freetexts: form.freetexts.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),

    revokeBoardDecisionsProcura: form.revokeBoardDecisionsProcura.value,
  };
}

export const procuraHandler: DecisionTypeHandler<DecisionType.procura, Procura, ProcuraForm> = {
  type: DecisionType.procura,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
